var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyclipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9231 5H6.07692C5.48215 5 5 5.48215 5 6.07692V10.9231C5 11.5178 5.48215 12 6.07692 12H10.9231C11.5178 12 12 11.5178 12 10.9231V6.07692C12 5.48215 11.5178 5 10.9231 5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61538 8H2.07692C1.79131 8 1.51739 7.88654 1.31542 7.68458C1.11346 7.48261 1 7.2087 1 6.92308V2.07692C1 1.79131 1.11346 1.51739 1.31542 1.31542C1.51739 1.11346 1.79131 1 2.07692 1H6.92308C7.2087 1 7.48261 1.11346 7.68458 1.31542C7.88654 1.51739 8 1.79131 8 2.07692V2.61538",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyclipboard);
export default __webpack_public_path__ + "static/media/copyclipboard.bdd58e89ad6621445763057cd2defa27.svg";
export { ForwardRef as ReactComponent };